import React from "react";
import Aux from "../../../hoc/Auxilliary";
import TopItem from "./TopItem";
import Container from "./TableContainer";

function AttendanceContent() {
  return (
    <Aux>
      <TopItem />
      <Container />
    </Aux>
  );
}

export default AttendanceContent;
